import React from "react";
import { Bell, ChevronDown, Check, Sparkles } from "lucide-react";
import { useOpsRole } from "../../context/OpsRoleContext";
import { useOpsUI } from "./OpsLayout";
import { ROLES } from "../../lib/ops";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "../ui/dropdown-menu";

export default function OpsTopBar({ title, subtitle, right }) {
  const { role, setRole } = useOpsRole();
  const { openAI } = useOpsUI();
  const current = ROLES.find((r) => r.key === role) || ROLES[0];

  return (
    <header className="sticky top-0 z-20 flex items-center gap-4 px-6 sm:px-8 py-4 border-b backdrop-blur-md" style={{ background: "rgba(247,248,246,.85)", borderColor: "#E7E8E4" }}>
      <div className="min-w-0">
        {title && <h1 className="text-lg font-bold tracking-tight text-ink truncate">{title}</h1>}
        {subtitle && <p className="text-sm text-ink-2 truncate">{subtitle}</p>}
      </div>

      <div className="ml-auto flex items-center gap-2.5">
        {right}
        <button onClick={openAI} className="btn-secondary focus-ring" data-testid="ops-ai-topbar"><Sparkles size={15} strokeWidth={1.75} /> Ask AI</button>

        {/* Role switcher — demo */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="btn-secondary focus-ring" data-testid="ops-role-switcher">
              {current.label} <ChevronDown size={15} strokeWidth={1.75} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-60">
            <DropdownMenuLabel>View as (demo)</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {ROLES.map((r) => (
              <DropdownMenuItem key={r.key} onClick={() => setRole(r.key)} data-testid={`ops-role-${r.key}`} className="flex items-start justify-between gap-3">
                <span><span className="font-medium">{r.label}</span><span className="block text-xs text-ink-3">{r.hint}</span></span>
                {role === r.key && <Check size={14} strokeWidth={2} color="#678A16" className="mt-1" />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        <button className="btn-ghost focus-ring relative" data-testid="ops-notifications">
          <Bell size={18} strokeWidth={1.5} />
          <span className="absolute top-1.5 right-2 w-1.5 h-1.5 rounded-full" style={{ background: "#93C020" }} />
        </button>
      </div>
    </header>
  );
}
